import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=6421f90b&scoped=true&"
import script from "./EditTable.vue?vue&type=script&lang=js&"
export * from "./EditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421f90b",
  null
  
)

export default component.exports